import { LuMinus } from "react-icons/lu";
import { svgLinks } from "../public/assets/assetLinks.ts";
import { BaseAccordionProps, pricingCardType } from "@/components/ui";
import { GoPlus } from "react-icons/go";

export const pricingdata: pricingCardType[] = [
  {
    title: "Basic Qoonity",
    text: "Perfect for individual developers and small teams.",
    price: 20,
    cardStyle: "bg-[#0B0C0E]",
    feature: [
      {
        name: "Access to Java, Kotlin & python generation",
      },
      { name: "Unlimited prompts" },
      { name: "Boilerplate automation" },
      { name: "Code refactor suggestions" },
      { name: "Email support" },
    ],
    buttonLabel: "Current plan",
    buttonState: "tertiary",
  },
  {
    title: "Qoonity Enterprise",
    text: "Designed for teams and organizations with advanced needs.",
    price: 42,
    cardStyle: "bg-[#750505]",
    iconStyle: "bg-[#FFFFFF14]",
    feature: [
      {
        name: "Everything in Basic, plus:",
        icon: <img src={svgLinks.instantcode} className="w-4" />,
      },
      { name: "Team collaboration & shared workspaces" },
      { name: "Priority support & dedicated account manager" },
      { name: "Custom model tuning" },
      { name: "API access for integration" },
    ],
    buttonLabel: "Upgrade plan",
    buttonState: "white",
  },
];

export const AccordionData: BaseAccordionProps = {
  expandMultiple: true,
  expandByDefault: false,
  defaultExpandedIndex: 0,
  accordionItems: [
    {
      title: "How does Qoonity work?",
      message:
        "Qoonity is a modern development platform that helps developers scaffold backend logic faster using AI-powered tools.",
      expandIcon: GoPlus,
      collapseIcon: LuMinus,
      iconPosition: "end",
    },
    {
      title: "What languages does Qoonity support?",
      message:
        "Currently, Qoonity supports Java, Kotlin, and Python, with more languages coming soon.",
      expandIcon: GoPlus,
      collapseIcon: LuMinus,
    },
    {
      title: "Can I cancel my subscription?",
      message:
        "While Qoonity is currently focused on backend scaffolding, frontend support is on our roadmap.",
      iconPosition: "start",
    },
    {
      title: "What’s included in the Enterprise plan?",
      message:
        "Yes, we offer a free plan with limited features to help you explore Qoonity before committing to a paid plan.",
    },
  ],
};

export const featuresdata = [
  {
    title: "Real-time Code Generation",
    text: "Generate code in seconds from natural language input.",
  },
  {
    title: "Multi-Language Support",
    text: "Supports Java, Kotlin, and Python — with more coming soon.",
  },
  {
    title: "Boilerplate Automation",
    text: "Save hours by skipping repetitive setup and structure code.",
  },
  {
    title: "Intuitive Prompting",
    text: "Smart and simple interface built for developers.",
  },
  {
    title: "Conversational Coding",
    text: "Like ChatGPT — but focused on clean code and dev speed.",
  },
  {
    title: "Code Refactoring Suggestions",
    text: "Instantly improve existing code with smart AI-driven suggestions.",
  },
];